import React, { Component } from "react";
import { Row, Col, Card } from "antd";

export default class IndexList extends Component {
  render() {
    let isAdmin = tool.getCookie('roleCodes').includes('ROLE20211207005')
    let list = []
    if(isAdmin){
      list = this.props.list.filter(el=>{
        return !['待还款', '已融资', '统计报表'].includes(el.type)
      })
    }else{
      list = this.props.list.filter(el=>{
        return !['统计报表'].includes(el.type)
      })
    }
    return (
      <div>
        <Row gutter={16}>
        {
            list.map(el=>{
              let {count} = el
              if(el.format){
                count = el.format(count, 2)
              }
              return (
                <Col span={this.props.span} style={{marginBottom:'15px'}}>
                  <Card bordered={false} style={{boxShadow: '0 0 4px 0 rgb(57 103 153 / 20%)'}}>
                    <div style={{display:'flex',height:'70px'}}>
                      <div style={{width:'70px'}}>
                        <img src={el.img} style={{width:'70px',height:'70px'}}></img>
                      </div>
                      <div className="left" style={{flex:1,boxSizing:'border-box',paddingLeft:'15px'}}>
                        <div style={{height:'35px',lineHeight:'35px',fontSize:'16px'}}>
                          {el.type}
                        </div>
                        <div style={{height:'35px',lineHeight:'35px',fontSize:'24px',fontWeight:'400'}}>
                          {el.prefix?(el.prefix+count):count}
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              )
            })
          }
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Factor/IndexList.js